import { beaconSystemFontSizeSansSerifCaption300BreakpointDefault } from '@trp-beacon-ui-kit/foundation/style-tokens/js/variables';
import { BeaconChartBase } from '@trp-beacon-ui-kit/foundation/components';
import { Constants as ProductCenterTableWrapperConstants } from '../../../product-center-table-wrapper/product-center-table-wrapper.constants';
import { formatDecimalAsPercentage } from '../../../../common/utils/formatNumber';
import { customFormatDate } from '../../../../common/utils/formatDate';
import { getAPCDateFormat } from '../../../product-center-table-wrapper/product-center-table-wrapper.utils';

export const Constants = {
  TAG_NAME: 'pop-pc-tile-component',
  POPOVER_TAG: 'pop-product-center-popover',
  TRANSLATION_KEYS: {
    APIR: 'apir',
    ISIN: 'isin',
    INCEPTION: 'tables.performance.headers.inception_date',
    AS_OF: 'as_of',
  },
  RESIZE_EVENT: 'resize',
  CLOSE_EVENT: 'close',
  ELEMENT_CLASS: {
    CARET_UP: 'caret-up',
    HIDE_CHART: 'hide-chart-content',
    CHART_TOGGLE: 'chart-toggle',
  },
  FORMAT_OPTIONS: {
    NUMERIC: 'numeric',
    TWO_DIGIT: '2-digit',
    SHORT: 'short',
  },
  SELECTED_PRODUCT_EVENT: 'selected-product-change',
  DATA_PRODUCTS_GROUP: 'data-products-group',
  DATA_SELECTED_PRODUCT: 'data-selected-product',
  CUMULATIVE_DATA_FIELDS: {
    FUND_VALUE: 'fundValue',
    BENCHMARK_VALUES: 'benchmarkValues',
  },
  DATA_POINT_DECIMAL_PLACES: 2,
  TICK_INTERVAL_FOR_TEN_YEARS: 2,
  CHART_CONFIG: {
    chart: {
      height: 290,
      alignTicks: true,
      spacingBottom: 170,
      marginBottom: 170,
    },
    yAxis: {
      tickInterval: 50,
      min: 0,
      labels: {
        formatter: function () {
          const label = this.axis.defaultLabelFormatter.call(this);
          return `${label}%`;
        },
      },
    },
    xAxis: {
      tickInterval: undefined as number | undefined,
      tickLength: 5,
      tickWidth: 2,
      tickmarkPlacement: 'on',
      labels: {
        rotation: -45,
        margin: 20,
        formatter: function () {
          return this.value;
        },
      },
    },
    legend: {
      floating: true,
      layout: 'vertical',
      x: 0,
      y: 170,
    },
    tooltip: {
      formatter: function () {
        const asOfDate = this.points[0].point.asOfDate
          ? getAPCDateFormat(
              customFormatDate(
                this.points[0].point.asOfDate,
                ProductCenterTableWrapperConstants.DATE_FORMATS
                  .MEDIUM_DATE_FORMAT,
              ),
            )
          : '';

        const header = `<span style="font-size: ${beaconSystemFontSizeSansSerifCaption300BreakpointDefault}">${asOfDate}</span><br/>`;
        const body = this.points
          .map((point) => {
            const yValueAsPercentage = `<span style="font-size: ${beaconSystemFontSizeSansSerifCaption300BreakpointDefault}">
            ${formatDecimalAsPercentage(point.y, Constants.DATA_POINT_DECIMAL_PLACES)}</span>`;

            return `
              ${BeaconChartBase.tooltipPointHTML(
                point,
                `<span style="font-size: ${beaconSystemFontSizeSansSerifCaption300BreakpointDefault}">${point.series.name}</span>`,
                yValueAsPercentage,
              )}`;
          })
          .join('');
        return `${header}${body}`;
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
      },
    },
  },
} as const;
